module.exports = __webpack_public_path__ + "img/payment-pic-10.15ff5c78.png";